import React from "react";
import MatrixRain from "../components/MatrixRain";
import { Footer } from "../components/Sections";
import { usePageTracking } from "../analytics";
import {
  UrgencyBar,
  BrandHeader,
  VslFacade,
  ApplyCTA,
  FounderBlock,
  OfferStackGrid,
  Testimonials,
  WALL_TESTIMONIALS,
  WhatHappensNext,
  ApplyFormV2,
  FaqAccordion,
  StickyApplyBar,
} from "../components/FunnelV2Parts";

const VslV2Page = () => {
  usePageTracking("vsl_v2");
  return (
    <div className="min-h-screen bg-[#050505] pb-24 sm:pb-20">
      <UrgencyBar />
      <div className="relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-[320px] opacity-60">
          <MatrixRain />
          <div className="matrix-fade" />
        </div>
        <div className="relative z-10">
          <BrandHeader />

          {/* Headline + video */}
          <section className="mx-auto max-w-4xl px-4 pt-2 text-center">
            <h1 className="text-balance text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-5xl">
              How To Read Market Time and Price Cycles So You Know When and Where Price Moves —{" "}
              <span className="text-[#16E36F]">Before It Happens.</span>
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-base text-slate-400 sm:text-lg">
              Watch this free training to see the framework 400+ traders use to trade with
              conviction instead of hope.
            </p>
          </section>

          <div className="space-y-14 pb-16 pt-8 sm:space-y-20">
            <div className="px-4">
              <VslFacade />
            </div>
            <ApplyCTA label="Apply Now" testid="vsl-cta-1" />
            <FounderBlock />
            <OfferStackGrid />
            <ApplyCTA label="Start Application" testid="vsl-cta-2" />
            <Testimonials title="What Students Are Saying" items={WALL_TESTIMONIALS} />
            <WhatHappensNext title="What Happens After You Apply" />
            <div className="px-4">
              <ApplyFormV2 funnel="vsl_v2" />
            </div>
            <ApplyCTA label="Apply Now" testid="vsl-cta-3" />
            <FaqAccordion />
          </div>
        </div>
      </div>
      <Footer />
      <StickyApplyBar />
    </div>
  );
};

export default VslV2Page;
